import { get } from 'lodash'

// Active years only include years the school already has approved details for.
// After rollover the survey is often the previous year, so prefer the year
// nested on the survey itself and fall back to an active-year lookup.
export function resolveSurveySchoolYear(surveyAttempt, activeSchoolYears) {
  if (!surveyAttempt) return
  const fromSurvey = get(surveyAttempt, 'survey.schoolYear')
  if (fromSurvey && fromSurvey.id) return fromSurvey
  if (!activeSchoolYears) return
  const surveySchoolYearId = get(surveyAttempt, 'survey.schoolYearId')
  return activeSchoolYears.find((year) => year.id == surveySchoolYearId)
}

export function withSurveySchoolYear(schoolYears, surveySchoolYear) {
  if (!schoolYears && !surveySchoolYear) return
  const years = schoolYears ? [...schoolYears] : []
  if (
    surveySchoolYear &&
    !years.some((year) => year.id == surveySchoolYear.id)
  ) {
    years.push(surveySchoolYear)
  }
  return years
}
